<template>
  <div class="brand-bar">
    <div class="container">
      <LanguageSelector/>
    </div>
  </div>
</template>

<script>
  import LanguageSelector from "./LanguageSelector";

  export default {
    name: "BrandBar",
    components: {LanguageSelector},
  };
</script>

<style lang="scss">
.brand-bar {
  color: $black;

  .container {
    display: flex;
    justify-content: space-between;
    height: 100%;

    img {
      display: block;
      max-width: 150px;
      max-height: 100px;
      width: auto;
      height: auto;
      padding-bottom: 10px;
    }
  }
}
</style>
